import React, { useRef, useState,Suspense, useEffect } from "react";
import { Canvas,useThree, useFrame } from "@react-three/fiber";
import {
  Environment,
  OrbitControls,
  useProgress,
  Preload,
} from "@react-three/drei";
import "./styles.css";
import { Ark } from "./Ark";
import gsap from "gsap";
import { Effects } from "./Effects";

function CustomCamera() {
  const ref = useRef();


  const {camera} = useThree()


  let easing = 'power2.out'
  let duration = 3.5

  function Section1() {
     
    gsap.to(ref.current.target,{
      x: 0,
      y: 5,
      z: 0,
      ease: easing,
      duration: duration
    })

    gsap.to(camera.position,{
      x: 5,
      y: 3,
      z: 10,
      ease: easing,
      duration: duration
    })
    ref.current.maxAzimuthAngle =Infinity
      ref.current.minAzimuthAngle = Infinity
    document.querySelectorAll('p')[0].classList.add('active-text')
    document.querySelectorAll('p')[1].classList.remove('active-text')
    document.querySelectorAll('p')[2].classList.remove('active-text')

    document.querySelector('#section-3').style.opacity = 0
    document.querySelector('.hidden-section').style.display = 'none'

    document.querySelector('#section-3').classList.remove('active-text')
    document.querySelector('#section-3').style.pointerEvents  = "none"


  }

  function Section2() {
    gsap.to(ref.current.target,{
      x: 5,
      y: 5,
      z: 0,
      ease: easing,
      duration: duration
    })

    gsap.to(camera.position,{
      x: 10.5,
      y: 3,
      z: 6.09,
      ease: easing,
      duration: duration
    })
    ref.current.maxAzimuthAngle =Infinity
      ref.current.minAzimuthAngle =Infinity

    document.querySelectorAll('p')[1].classList.add('active-text')
    document.querySelectorAll('p')[0].classList.remove('active-text')
    
    document.querySelector('#section-3').style.opacity = 0
    document.querySelector('.hidden-section').style.display = 'none'

    document.querySelector('#section-3').classList.remove('active-text')
    document.querySelector('#section-3').style.pointerEvents  = "none"

  }

  function Section3() {
        gsap.to(ref.current.target,{
        x: -1.81,
        y: 3.91,
        z: 14.88,
        ease: easing,
        duration: duration,
        onComplete: function(){
          // setTimeout(() =>{
          //   ref.current.maxAzimuthAngle =- Math.PI* 0.8
          //   ref.current.minAzimuthAngle = Math.PI* 0.8
          // },2200)
        }
      })
  
      gsap.to(camera.position,{
        x: 12.00,
        y: 12,
        z: -5.43,
        ease: easing,
        duration: duration,
        onComplete: function(){

           
          document.querySelector('.hidden-section').style.display = 'block'

        }
      })


      document.querySelectorAll('p')[0].classList.remove('active-text')
      document.querySelectorAll('p')[1].classList.remove('active-text')

      document.querySelector('#section-3').style.opacity = 1

      document.querySelector('#section-3').classList.add('active-text')
      document.querySelector('#section-3').style.pointerEvents  = "all"

  }

  let section = 0

  let startY = 0;

  if(window.innerWidth < 550){
     

    useEffect(() => {


      const isMobile = window.innerWidth <= 768; // You can adjust the threshold

      if (isMobile) {

      Section1();
    
      const handleTouchStart = (event) => {
        startY = event.changedTouches[0].clientY;
      };
    
      const handleTouchMove = (event) => {
        const deltaY = event.changedTouches[0].clientY - startY;
    
        if (deltaY < 0) {
          if (section === 0) {
            section = 1;
            Section2();

          } else if (section === 1) {
            section = 2;
            Section3();
          }

       
          
        } else if (deltaY > 0) {
          if (section === 2) {
            section = 1;
            Section2();
           
          } else if (section === 1) {
            section = 2;
            Section1();
          }
        }
      };
    
      window.addEventListener("touchstart", handleTouchStart);
      window.addEventListener("touchmove", handleTouchMove);
    
      return () => {
        window.removeEventListener("touchstart", handleTouchStart);
        window.removeEventListener("touchmove", handleTouchMove);
      };
    }

    }, [section]);
    

  }



  useEffect(() =>{

    Section1()

    window.addEventListener('wheel', function(event)
  {
   if (event.deltaY < 0)
   {



    if(section == 0){
      section = 0

      Section1()

    }

   else if(section == 1){
      section = 0

      Section2()

    }

    else {
      section -= 1
    }
 


    
   }
   else if (event.deltaY > 0)
   {


    if(section == 1){
      section = 1

      Section2()

    }

    if(section == 3){
      section = 2

      Section3()

       console.log('section 3')
    }

    else {
      section += 1
        }


     }


   
  });
  
  },[])

  
  return (
    <OrbitControls
      ref={ref}
      enableRotate={true}
      enablePan={false}
      enableZoom={false}
      autoRotate={false}
      rotateSpeed={1.8}
      maxPolarAngle={Math.PI / 2.1}
      minPolarAngle={Math.PI / 2.1}
   
    />
     
  
  );
}

export default function App() {

  const { active, progress, errors, item, loaded, total } = useProgress()



  return  <>

   {progress !== 100 ?

<div className="Preloader">
     <div className="Art-icon">
       <p>{progress}</p>
     </div>
     </div>

     
     : console.log('loaded')
   }

    <div className="hidden-section" ></div>
    <div className="dark-overlay"></div>
    <p id="section-1-text">In the year 3000, humanity reached new frontiers and evolved into unique bionic species propelled by advanced technology. However, as they grew into mechanical beings, a deep sense of disconnection began to pervade their lives. Yearning for a way to reignite the human connection and undo this curse, a group of visionary explorers emerged.</p>
    <p id="section-2-text">Their journey commenced with a quest to find the Lost Souls, rumoured to be the last group of individuals who retains human form. The Explorers observed a curious blip on their radar and descended. Working through the piles of sand and debris, they were able to unveil the shuttle’s name, The Ark etched onto its hull.</p>
    <div id="section-3">
    <p id="section-3-text">After much experiment, the vessel’s true secret was unveiled— an energy source fueled not by conventional means, but by the power of happiness itself. In their moment of celebration, their collective joy had triggered the long-dormant mechanisms of The Ark, breathing life into the vessel.</p>
    <button onClick={() => window.open('https://theark11.com/contact/')}  >Join us on this journey to search for the Lost Souls</button>
    </div>

    <Canvas
      dpr={[1, 1.5]}
      gl={{ alpha: false, antialias: false }}
      camera={{ fov: 60, position: [0, 6, 8] }}
    >
      <ambientLight />

        <CustomCamera />
        <Preload all />

        <Ark />


      <Suspense>
        <Environment
          files={
            "environment.hdr"
          }
        />
      </Suspense>

      <Effects/>

      

      {/* <Scene /> */}
    </Canvas>
    </>
}
